// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1JfwZ","list":"BalanceDue_list__9XJ-z","listRow":"BalanceDue_listRow__oyoU3","total":"BalanceDue_total__2zaYv"};